import { render, staticRenderFns } from "./AppLauncherOptions.vue?vue&type=template&id=09665512&scoped=true"
import script from "./AppLauncherOptions.vue?vue&type=script&lang=ts"
export * from "./AppLauncherOptions.vue?vue&type=script&lang=ts"
import style0 from "./AppLauncherOptions.vue?vue&type=style&index=0&id=09665512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.23_css-loader@7.1.2_webpack@5.102.1__ejs@3.1.1_20dff8951f95f44cc1d7dd775e2ec0ac/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09665512",
  null
  
)

export default component.exports